import type { Topic } from '../types';
import { auswertung } from './auswertung';
import { banner } from './banner';
import { blockieren } from './blockieren';
import { einrichtung } from './einrichtung';
import { konto } from './konto';

/**
 * Every help topic, in one object.
 *
 * Split into five files by group because one file of twenty-one topics is a file nobody
 * reviews. Joined here so that `TopicSlug` is a union of the actual slugs: a `<Hilfe
 * to="tippfehler" />` is then a type error in `pnpm typecheck`, which is CI, rather than a
 * question mark that opens an empty dialog in production.
 */
export const TOPICS = {
  ...einrichtung,
  ...banner,
  ...blockieren,
  ...auswertung,
  ...konto,
} satisfies Record<string, Topic>;

export type TopicSlug = keyof typeof TOPICS;

export const isTopicSlug = (s: string): s is TopicSlug => s in TOPICS;
